import '../CsvJsonInfoPages.scss';


function GenericOptionLink() {

    const data = [
        { field: 1, description: 'Option Code (Int)' },
        { field: 2, description: 'Generic Code (Int)' },
    ];

    return (
        <div className='csv-json-info-pages-container'>
            <h1>New Vehicle Data Enhanced - Generic Option Link</h1>
            <p>This file contains the links between Options and Generic items.<br /><br />
                <b>File Naming Convention</b><br /><br />
                The Filename is dependant on the product being produced as follows.<br /><br />

                CAR_yyyy-mm-dd_NVDDictionaryOptionGenericLink.txt<br />
                LIGHTS_yyyy-mm-dd_NVDDictionaryOptionGenericLink.txt<br />
                HEAVIES_yyyy-mm-dd_NVDDictionaryOptionGenericLink.txt<br />
                BIKES_yyyy-mm-dd_NVDDictionaryOptionGenericLink.txt<br /><br />

                Note: yyyy-mm-dd represents the date of the product. E.g. 2003-07-01 would represent the date 1st July 2003.
            </p>
            <table>
                <thead>
                    <tr>
                        <th>Field</th>
                        <th>DATA</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((item, index) => (
                        <tr key={index}>
                            <td>{item.field}</td>
                            <td>{item.description}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <p>
                Note: A manufacturer code of zero means the option is Common to multiple manufacturers.
            </p>
        </div>
    );
}

export default GenericOptionLink;
